export default __webpack_public_path__ + "static/media/startup-evaluation-icon.0451c69f.svg";